// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1QR0R","content":"LoadingAlert_content__gUccw"};